import { z } from 'zod';

import { ProjectRole, ProjectStatus } from '../enums.js';

import { HexColor, Ulid } from './common.js';

export const Project = z.object({
  id: Ulid,
  name: z.string().min(1).max(120),
  slug: z.string().min(1).max(140),
  description: z.string().nullable(),
  color: HexColor,
  status: ProjectStatus,
  activeFlowchartId: Ulid.nullable(),
  createdByUserId: Ulid,
  notes: z.string().default(''),
  settings: z.record(z.unknown()),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
  archivedAt: z.string().datetime().nullable(),
});
export type Project = z.infer<typeof Project>;

export const ProjectCreate = z.object({
  name: z.string().min(1).max(120),
  description: z.string().max(2000).optional(),
  color: HexColor.default('#1F3A5F'),
  /** Seed flowchart template name. 'default-sales' creates the canonical sales pipeline. */
  seedFlowchart: z.enum(['default-sales', 'empty']).default('default-sales'),
  settings: z.record(z.unknown()).optional(),
});
export type ProjectCreate = z.infer<typeof ProjectCreate>;

export const ProjectUpdate = z
  .object({
    name: z.string().min(1).max(120),
    description: z.string().max(2000).nullable(),
    color: HexColor,
    notes: z.string().max(20_000),
    settings: z.record(z.unknown()),
  })
  .partial();
export type ProjectUpdate = z.infer<typeof ProjectUpdate>;

export const ProjectMember = z.object({
  projectId: Ulid,
  userId: Ulid,
  projectRole: ProjectRole,
  addedByUserId: Ulid,
  joinedAt: z.string().datetime(),
});
export type ProjectMember = z.infer<typeof ProjectMember>;

export const ProjectMemberAdd = z.object({
  userId: Ulid,
  projectRole: ProjectRole.default('member'),
});
export type ProjectMemberAdd = z.infer<typeof ProjectMemberAdd>;
